module.exports = __webpack_public_path__ + "img/DE01718.dde3884a.png";